/**
 * NexusDent — front-end app
 * Tiny vanilla JS for dev-pages pin, tabs, accordion, sticky sub-nav.
 */
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        initDevPages();
        initTabs();
        initAccordion();
        initSubnav();
        initModulesShowcase();
        initFaqLegacy();
        initFaq2();              // feature-page FAQ (.faq2)
        initFeatureSubnav();     // feature-page sticky sub-nav (.sn)
        initMessagingTabs();     // patients › §07 Comunicare channel switcher
        initSearchFilters();     // patients › §08 Căutare filter panels
        initShowcaseSlider();    // mobile › §02 Ecrane principale slider arrows
    });

    /* ── Feature-page FAQ (.faq2) — replaces inline onclick handlers ── */
    function initFaq2() {
        document.querySelectorAll('.faq2-q').forEach(function (q) {
            q.addEventListener('click', function () {
                var item = q.closest('.faq2-item');
                if (item) item.classList.toggle('open');
            });
        });
    }

    /* ── Feature-page sticky sub-nav (.sn) — IntersectionObserver + smooth scroll ── */
    function initFeatureSubnav() {
        var navLinks = document.querySelectorAll('.sn-link');
        if (!navLinks.length) return;

        // Match any block element with an id — the feature sections on
        // patients / treatment-plans are `.block.deep[id="..."]`, so the
        // earlier `.fs[id]` selector matched none of them.
        var sections = Array.from(document.querySelectorAll('.block[id], section[id]'));

        // Scroll-driven active link. Find the last section whose top has
        // crossed a trigger line ~200 px below the fixed nav stack and
        // mark its matching `.sn-link` active. More reliable than the
        // IntersectionObserver `intersectionRatio` threshold: a ~2 000 px
        // section never reaches a high ratio against the small middle band
        // defined by `rootMargin`, so the observer never fired and the very
        // first link stayed `active`.
        function setActive(id) {
            navLinks.forEach(function (link) {
                link.classList.toggle('active', link.getAttribute('href') === '#' + id);
            });
        }
        function updateActiveSection() {
            var trigger = window.scrollY + 200;
            var current = sections[0];
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].offsetTop <= trigger) current = sections[i];
                else break;
            }
            if (current && current.id) setActive(current.id);
        }
        // Throttle with rAF so the lookup runs at most once per frame.
        var ticking = false;
        window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                updateActiveSection();
                ticking = false;
            });
        }, { passive: true });
        // Initialize on load — handles deep-link entries (e.g. `#documente`).
        updateActiveSection();

        navLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                var href = link.getAttribute('href') || '';
                if (!href.startsWith('#')) return;
                var target = document.getElementById(href.slice(1));
                if (!target) return;
                e.preventDefault();
                // Account for the fixed top nav stack (96 px) + the sticky sub-nav (~60 px)
                var offset = 160;
                window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
            });
        });
    }

    /* ── Patients §07 Comunicare — channel switcher ── */
    function initMessagingTabs() {
        var tabs = document.querySelectorAll('#msg-tabs .pf-subtab');
        if (!tabs.length) return;
        var contents = document.querySelectorAll('.msg-channel-content');
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var ch = tab.dataset.ch;
                tabs.forEach(function (t) { t.classList.toggle('on', t === tab); });
                contents.forEach(function (c) {
                    c.style.display = c.dataset.ch === ch ? '' : 'none';
                });
            });
        });
    }

    /* ── Mobile §02 Ecrane principale — slider prev/next arrows ── */
    function initShowcaseSlider() {
        var slider = document.getElementById('showcase-slider');
        if (!slider) return;
        var track = slider.querySelector('.showcase-grid');
        var prev  = slider.querySelector('[data-slider-nav="prev"]');
        var next  = slider.querySelector('[data-slider-nav="next"]');
        if (!track || !prev || !next) return;

        function step() {
            var first = track.firstElementChild;
            if (!first) return track.clientWidth;
            // Card width + gap between cards
            var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
            return first.getBoundingClientRect().width + gap;
        }
        function update() {
            var max = track.scrollWidth - track.clientWidth - 2;
            prev.disabled = track.scrollLeft <= 2;
            next.disabled = track.scrollLeft >= max;
        }
        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    /* ── Patients §08 Căutare — filter panel + basic/advanced toggle ── */
    function initSearchFilters() {
        var filterBtn   = document.getElementById('cs-filter-btn');
        var filterPanel = document.getElementById('cs-filter-panel');
        if (filterBtn && filterPanel) {
            filterBtn.addEventListener('click', function () {
                var isOpen = filterPanel.style.display !== 'none';
                filterPanel.style.display = isOpen ? 'none' : '';
                filterBtn.classList.toggle('on', !isOpen);
            });
        }

        var modeToggle = document.getElementById('filter-mode-toggle');
        var viewBasic  = document.getElementById('filter-view-basic');
        var viewAdv    = document.getElementById('filter-view-adv');
        if (modeToggle && viewBasic && viewAdv) {
            modeToggle.addEventListener('click', function () {
                var cur = modeToggle.dataset.mode;
                if (cur === 'basic') {
                    viewBasic.style.display = 'none';
                    viewAdv.style.display = '';
                    modeToggle.dataset.mode = 'adv';
                    modeToggle.textContent = '← Trece la filtre de bază';
                } else {
                    viewBasic.style.display = '';
                    viewAdv.style.display = 'none';
                    modeToggle.dataset.mode = 'basic';
                    modeToggle.textContent = 'Trece la filtre avansate →';
                }
            });
        }
    }

    /* ── Modules showcase (homepage) — auto-advancing tabs ── */
    function initModulesShowcase() {
        var root = document.getElementById('module-showcase');
        if (!root) return;
        var tabs  = root.querySelectorAll('.ms-tab');
        var panes = root.querySelectorAll('.ms-pane');
        var prog  = document.getElementById('ms-progress');
        if (!tabs.length || !panes.length) return;

        var order = Array.from(tabs).map(function (t) { return t.dataset.mod; });
        var timer = null;
        var userInteracted = false;

        function activate(key, fromUser) {
            tabs.forEach(function (t) { t.classList.toggle('active', t.dataset.mod === key); });
            panes.forEach(function (p) { p.classList.toggle('active', p.dataset.pane === key); });
            if (prog) {
                prog.classList.remove('run'); void prog.offsetWidth; prog.classList.add('run');
            }
            if (fromUser) {
                userInteracted = true;
                if (timer) { clearInterval(timer); timer = null; if (prog) prog.classList.remove('run'); }
            }
        }
        function next() {
            var current = root.querySelector('.ms-tab.active');
            if (!current) return;
            var i = order.indexOf(current.dataset.mod);
            activate(order[(i + 1) % order.length], false);
        }
        tabs.forEach(function (t) {
            t.addEventListener('click', function () { activate(t.dataset.mod, true); });
        });

        function startAuto() {
            if (prog) prog.classList.add('run');
            timer = setInterval(function () { if (!userInteracted) next(); }, 8000);
        }
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (e.isIntersecting && !timer && !userInteracted) startAuto();
                });
            }, { threshold: 0.3 });
            io.observe(root);
        } else {
            startAuto();
        }
    }

    /* ── Legacy FAQ accordion + category filter (homepage) ── */
    function initFaqLegacy() {
        document.querySelectorAll('#faq-list .faq-q').forEach(function (q) {
            q.addEventListener('click', function () {
                q.parentElement.classList.toggle('open');
            });
        });
        document.querySelectorAll('#faq-cats .faq-cat').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var cat = btn.dataset.cat;
                document.querySelectorAll('#faq-cats .faq-cat').forEach(function (b) {
                    b.classList.toggle('active', b === btn);
                });
                document.querySelectorAll('#faq-list .faq-item').forEach(function (item) {
                    var show = (cat === 'all') || (item.dataset.cat === cat);
                    item.classList.toggle('hidden', !show);
                    if (!show) item.classList.remove('open');
                });
            });
        });
    }

    function initDevPages() {
        var panel = document.querySelector('.dev-pages');
        if (!panel) return;
        var pinned = localStorage.getItem('nd:dev-pages:pinned') === '1';
        if (pinned) panel.classList.add('pinned');

        var show = panel.querySelector('.show');
        if (!show) return;
        show.addEventListener('click', function (e) {
            e.preventDefault();
            panel.classList.toggle('pinned');
            localStorage.setItem('nd:dev-pages:pinned', panel.classList.contains('pinned') ? '1' : '0');
        });
    }

    function initTabs() {
        document.querySelectorAll('.tabs').forEach(function (tabs) {
            var triggers = tabs.querySelectorAll('.tab-trigger');
            var panels   = tabs.querySelectorAll('.tab-panel');

            triggers.forEach(function (trig) {
                trig.addEventListener('click', function () {
                    var target = trig.getAttribute('data-target');
                    triggers.forEach(function (t) { t.classList.remove('active'); });
                    panels.forEach(function (p)   { p.classList.remove('active'); });
                    trig.classList.add('active');
                    if (target) {
                        var panel = tabs.querySelector(target);
                        if (panel) panel.classList.add('active');
                    }
                });
            });
        });
    }

    function initAccordion() {
        document.querySelectorAll('.accordion').forEach(function (acc) {
            acc.querySelectorAll('.accordion-trigger').forEach(function (trig) {
                trig.addEventListener('click', function () {
                    var item = trig.closest('.accordion-item');
                    if (!item) return;
                    item.classList.toggle('open');
                });
            });
        });
    }

    function initSubnav() {
        var nav = document.querySelector('.block-subnav');
        if (!nav) return;
        var links = nav.querySelectorAll('.subnav-link');
        if (!links.length) return;

        var sections = [];
        links.forEach(function (l) {
            var href = l.getAttribute('href') || '';
            if (!href.startsWith('#')) return;
            var sec = document.querySelector(href);
            if (sec) sections.push({ link: l, sec: sec });
        });

        if (!('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting && e.intersectionRatio > 0.18) {
                    sections.forEach(function (s) { s.link.classList.remove('active'); });
                    var hit = sections.find(function (s) { return s.sec === e.target; });
                    if (hit) hit.link.classList.add('active');
                }
            });
        }, { rootMargin: '-30% 0px -55% 0px', threshold: [0, 0.18, 0.5] });
        sections.forEach(function (s) { io.observe(s.sec); });
    }
})();
